/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface ConfigureClaimMappersRequest {
    tenantId: string;
}

/**
 * KeycloakTenantAdminApi - interface
 * 
 * @export
 * @interface KeycloakTenantAdminApiInterface
 */
export interface KeycloakTenantAdminApiInterface {
    /**
     * Backfills Keycloak IdP and client protocol mappers so upstream roles/groups flow to idp_roles/idp_groups JWT claims.
     * @summary Configure IdP role/group claim passthrough mappers
     * @param {string} tenantId Tenant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakTenantAdminApiInterface
     */
    configureClaimMappersRaw(requestParameters: ConfigureClaimMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Backfills Keycloak IdP and client protocol mappers so upstream roles/groups flow to idp_roles/idp_groups JWT claims.
     * Configure IdP role/group claim passthrough mappers
     */
    configureClaimMappers(requestParameters: ConfigureClaimMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class KeycloakTenantAdminApi extends runtime.BaseAPI implements KeycloakTenantAdminApiInterface {

    /**
     * Backfills Keycloak IdP and client protocol mappers so upstream roles/groups flow to idp_roles/idp_groups JWT claims.
     * Configure IdP role/group claim passthrough mappers
     */
    async configureClaimMappersRaw(requestParameters: ConfigureClaimMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling configureClaimMappers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/tenants/{tenantId}/keycloak/configure-claim-mappers`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Backfills Keycloak IdP and client protocol mappers so upstream roles/groups flow to idp_roles/idp_groups JWT claims.
     * Configure IdP role/group claim passthrough mappers
     */
    async configureClaimMappers(requestParameters: ConfigureClaimMappersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.configureClaimMappersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
